<app-resource-template [footerStickyEnabled]="footerStickyEnabled">
  <div resource-content class="accessibility-content" [innerHTML]="accessibilityContent"></div>
</app-resource-template>
